<template>
  <div id="main-wrapper">
    <Header v-show="!mobileSetting" />
    <Menu ref="mainMenu" v-show="!mobileSetting" />

    <Footer v-show="!mobileSetting" />

    <router-view></router-view>

    <notifications group="foo" />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Menu from "@/components/Menu";
import Footer from "@/components/Footer";
import EventBus from "../eventBus"

export default {
  name: "Main",

  data() {
    return {
      mobileSetting: false
    }
  },

  components: {
    Header,
    Menu,
    Footer
  },

  mounted() {
    localStorage.setItem('cacheVersion', Date.now())
    //detect mobile setting web view
    EventBus.$on("MOBILE_SETTING_CHECK_DONE", payload => {
      this.mobileSetting = payload
    })
  }
};
</script>
